import { createFileRoute, Outlet } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

export const Route = createFileRoute("/elbolag/elnat")({
  head: () => seoHead("/elbolag/elnat"),
  component: () => <Outlet />,
});
